import React, { useEffect, useRef, useState } from "react"
//@ts-ignore
import { Link, useParams } from "react-router-dom"
import {
  Divider,
  IconButton,
  InputBase,
  InputLabel,
  Paper,
  TextareaAutosize,
  makeStyles,
} from "@material-ui/core"
import AccessDenied from "src/components/access-denied"
import {
  AIIcon,
  CopyIcon,
  EditIcon,
  FileCopyIcon,
  SaveIcon,
  SaveIcon2,
  ShareIcon,
  TrashIcon2,
  exportIcon,
  notificationIcon,
  playIcon,
} from "src/components/icons-svg"
import consts, { SCR_APP_URLS } from "shared/consts"
import ConfirmationModal from "src/components/confirmation-modal"
import { getLibraryURL } from "src/utils/get-simulation-library-url"
import CustomModal from "src/components/custom-modal"
import store from "src/store"
import InputText from "src/components/input-text"
import copyToClipboard from "copy-to-clipboard"
import RenameCopiedSimulation from "src/components/rename-copied-simulation"
import useFeature from "../utils/subscriptionWrapper"
import OneSimulationHeader from "src/components/one-simulation-header"
import useIsLoggedIn from "src/utils/use-is-logged-in"
import Disclaimer from "src/components/disclaimer"
import Progress from "src/components/progress"
import PassFailChips from "src/components/pass-fail-chips"
import Tooltip from "src/components/tooltip"
import PrivateIcon from "src/components/private-icon"
import PublicIcon from "src/components/public-icon"
import { requestJSON } from "src/utils/request-module"
import { delay } from "src/utils/react-utils"
import VisualBlockchain from "./visual-blockchain"
import useHistory from "../use-history"
import useSCREffect from "../utils/scrEffect"
import Button from "src/components/button"
import CFloatButton from "src/components/cFloatButton"

function qs() {
  return require("qs").parse(location.search.slice(1))
}

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    border: "1px solid #000",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  label: {
    marginBottom: "12px",
  },
  navButtonDivider: {
    background: "#e0e0e0",
  },
  verticalDivider: {
    background: "#e0e0e0",
    height: "20px",
  },
  button: {
    margin: theme.spacing(1),
  },
  link: {
    color: "#799fd4",
    paddingLeft: "5px",
    textDecoration: "none",
  },
}))

export default function OneSimulation(props) {
  const history = useHistory()
  const classes = useStyles()
  const user = useIsLoggedIn()
  let id = ""

  if (props["simulationId"]) {
    id = props.simulationId
  } else {
    let params = useParams()
    id = params.id.replace(/[^a-z0-9]/gi, "")
  }

  const REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS = useFeature(
    consts.FEATURE_FLAG_REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS,
  )

  const [isCiReview, setIsCiReview] = useState(false)
  const [parentReviewId, setParentReviewId] = useState("")
  const [simulationError, setSimulationError] = useState(false)

  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)

  const [showRenameSimulationModal, setShowRenameSimulationModal] =
    useState(false)
  const [simulationName, setSimulationName] = useState("")
  const [simulationNameHasError, setSimulationNameHasError] = useState(false)
  const [simulationNameErrorText, setSimulationNameErrorText] = useState("")

  const [showShareableLinkModal, setShowShareableLinkModal] = useState(false)
  const [shareableLink, setShareableLink] = useState("")

  const [showCopySimulationTitleModal, setShowCopySimulationTitleModal] =
    useState(false)

  const [secondaryBtnLoading, setSecondaryBtnLoading] = useState(false)
  const [createSimulationUsingAIerr, setCreateSimulationUsingAIerr] =
    useState("")
  //=======on entry clearing all the data=======
  useEffect(() => {
    store.clearOneSimulationData()
  }, [id])

  //=======if simulation list avalilable and selected simulation object is blank then adding selected simulation=======
  useEffect(() => {
    if (!Object.entries(store.selectedSimulationData).length) {
      getSelectedSimulationMetaData()
      getSelectedSimulationMainData()
    }
  }, [store.allSimulations.length, store.selectedSimulationData, id])

  //=======if selected simulation and user is available then adding user readonly condition=======
  useEffect(() => {
    checkAndSetReadOnly()
  }, [user, store.selectedSimulationData.user, id])

  //=======if selected simulation and default simulation available then setting if selected simulation is default one or not=======
  useSCREffect(() => {
    if (
      Object.entries(store.defaultSimulationData).length &&
      Object.entries(store.selectedSimulationData).length
    ) {
      if (store.defaultSimulationData._id != store.selectedSimulationData._id) {
        store.isDefaultSimulation = false
        store.updateStore()
      } else {
        store.isDefaultSimulation = true
        store.updateStore()
      }
    } else {
      store.isDefaultSimulation = false
      store.updateStore()
    }
  }, [store.defaultSimulationData, store.selectedSimulationData, id])

  //=======If store.steps is present then check abi and update if required=======
  useSCREffect(() => {
    if (qs().review_id && store.steps.length) {
      for (let j = 0; j < store.steps.length; j++) {
        if (
          store.steps[j]["type"] === consts.STEP_TYPES.COMPILE_SMART_CONTRACT &&
          store.steps[j]["using_review_files"]
        ) {
          store.updateAbi(j)
        }
      }
    }
    if (store.steps.length) {
      store.updateByte32List()
      store.setByte32List()
    }
  }, [store.steps])

  // On unmount save story
  useEffect(() => {
    return () => {
      onCleanup()
    }
  }, [])

  const onCleanup = async () => {
    await store.saveStory()
    store.clearOneSimulationData()
  }

  const checkAndSetReadOnly = () => {
    store.isReadOnly = true
    store.updateStore()

    if (!user["isLoggedIn"]) {
      //checking if user not logged in or guest user then make readonly true
      store.isReadOnly = true
      store.simulationReviewId = ""
    } else if (user["isLoggedIn"] && !qs().review_id) {
      //checking if user not logged in or guest user but no review simulation then make readonly falseeck
      //@ts-ignore
      if ((store.selectedSimulationData.user || store.selectedSimulationData.createdByEmail) == user["isLoggedIn"].email) {
        //checking if the review is not owened by logged in user then make readonly true
        store.isReadOnly = false
      }
      store.simulationReviewId = ""
    } else if (user["isLoggedIn"] && (qs().review_id || store.selectedSimulationData.reviewId)) {
      checkIfCiReview()
      store.simulationReviewId = store.selectedSimulationData?.review_id
    } else if (
      user["isLoggedIn"] &&
      store.selectedSimulationData.organization
    ) {
      // @ts-ignore
      store.isReadOnly =
        user?.isLoggedIn?.email != store.selectedSimulationData.user
      store.simulationReviewId = ""
    } else {
      store.isReadOnly = false
      store.simulationReviewId = ""
    }
    store.viewOrEdit = "edit"
    store.updateStore()
  }

  const checkIfCiReview = async () => {
    try {
      let reviewData = await store.fetchOneReview(qs().review_id)

      if (reviewData["parentReviewID"]) {
        //checking if it is a ci review then make readonly true
        setIsCiReview(true)
        setParentReviewId(reviewData["parentReviewID"])
        store.isReadOnly = true
      } else {
        setIsCiReview(false)
        store.isReadOnly = false
      }
    } catch (err) {
      console.log("Some error has occured while checking is Ci review ", err)
    } finally {
      store.updateStore()
    }
  }

  const getSelectedSimulationMetaData = () => {
    if (
      store.selectedSimulationData._id !=
      store.selectedReviewData["defaultStepSimulationId"]
    ) {
      let selectedSimulationMetadata = store.allSimulations.find(
        (simulation) => simulation["_id"] == id,
      )
      store.selectedSimulationData = {
        ...store.selectedSimulationData,
        ...selectedSimulationMetadata,
      }
      store.updateStore()
    }
  }

  const getSelectedSimulationMainData = async () => {
    store.selectedSimulationMaindataLoading = true
    store.updateStore()

    if (qs().review_id) {
      await store.fetchSelectedReviewData()
    } else {
      store.selectedReviewData = {}
      store.updateStore()
    }

    if (store.selectedReviewData["defaultStepSimulationId"]) {
      await store.fetchDefaultStepSimulationData()
    } else {
      store.defaultSimulationData = {}
      store.updateStore()
    }

    let selectedSimulationMaindata = await store.getSelectedSimulationMainData(
      id,
    )
    // @ts-ignore
    store.currentStoryId = id
    store.selectedSimulationData = {
      ...store.selectedSimulationData,
      ...selectedSimulationMaindata,
    }
    store.updateStore()
    addSteps()
    store.results = selectedSimulationMaindata?.results || []
    store.isMainnet = selectedSimulationMaindata.isMainnet
    // eslint-disable-next-line no-prototype-builtins
    store.blockNumber = selectedSimulationMaindata.hasOwnProperty("blockNumber")
      ? selectedSimulationMaindata.blockNumber
      : null
    store.steps.forEach((x) => (x.collapsed = true))
    store.setAddressList()
    store.updateStore()
    store.selectedSimulationMaindataLoading = false
    store.updateStore()
    if (qs().review_id) {
      store.colapseAll(true)
    } else {
      store.colapseAll(false)
    }
  }

  const addSteps = () => {
    if (Object.entries(store.selectedSimulationData).length) {
      store.steps = store.selectedSimulationData?.steps || []
      store.updateStore()
    }

    if (
      Object.entries(store.defaultSimulationData).length &&
      store.selectedSimulationData._id !=
        store.selectedReviewData["defaultStepSimulationId"]
    ) {
      store.addDefaultSimulationData()
    }
  }

  const redirectToLogin = () => {
    location.href = window["config"].AUTH_UI
  }

  const deleteSimulation = async () => {
    // @ts-ignore
    store.removeSimulationById(id, user?.isLoggedIn?.name)
    setShowDeleteConfirmation(false)
    history.push(getLibraryURL())
  }

  const syncSimulationName = () => {
    setSimulationName(store.selectedSimulationData.name)
    if (store.selectedSimulationData.name) {
      setSimulationNameHasError(false)
      setSimulationNameErrorText("")
    } else {
      setSimulationNameHasError(true)
      setSimulationNameErrorText("Simulation name is required")
    }
  }

  const updateSimulationTitle = async () => {
    if (!simulationName) {
      setSimulationNameHasError(true)
      setSimulationNameErrorText("Simulation name is required")
      return false
    } else if(simulationName.trim().length > 200){
      setSimulationNameHasError(true)
      setSimulationNameErrorText("Simulation name cannot be more than 200 characters")
      return false
    } else {
      setSimulationNameHasError(false)
      setSimulationNameErrorText("")
      store.selectedSimulationData.name = simulationName
      store.updateStore()
      store.updateSimulationMetadataProperty("name", simulationName, id)
      store.updateSimulationMaindataProperty("name", simulationName, id)
      await store.updateOneSimulation(id, { name: simulationName })
      return true
    }
  }

  const onCreateSimulationUsingAIClick = async () => {
    if (!store.selectedSimulationData["review_id"]) {
      setCreateSimulationUsingAIerr("Invalid simulation.")
    } else if (
      !store.selectedReviewData ||
      !store.selectedReviewData["mainFileName"]
    ) {
      setCreateSimulationUsingAIerr("No review files found.")
    } else {
      setSecondaryBtnLoading(true)
      let updateResponse = await updateSimulationTitle()
      if (updateResponse) {
        try {
          let res = await store.getSimulationUsingAIJSON();
          if(res.AIresponse === "NA") {
            store.steps = [];
            store.updateStore();
            setSimulationNameHasError(true)
            setSimulationNameErrorText("Unable to create simulation. Please check the simulation title.")
          } else {
            store.steps = res.AIresponse;
            store.updateStore();
            addCreatedByAIFlag()
            store.closeEnterSimulationNameModal()
          }
        } catch (err) {
          setCreateSimulationUsingAIerr(
            "Some error has occured while creating simulation using AI",
          )
        }
      }
      setSecondaryBtnLoading(false)
    }
  }

  const addCreatedByAIFlag = () => {
    store.selectedSimulationData["createdByAI"] = true
    store.updateSimulationMetadataProperty("createdByAI", true, id)
    store.updateStore()
  }

  const copyShareableLink = () => {
    copyToClipboard(shareableLink)
    setShareableLink("")
    setShowShareableLinkModal(false)
    store.showToaster("info", "Link is copied successfully.")
  }

  const onSubmitCopiedSimulationName = async (newValue) => {
    if (!newValue) {
      return
    } else {
      let reqBody = {
        public: !REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS,
        simulationName: newValue,
        storyId: id,
        stayInSamePage: false,
      }

      try {
        await store.duplicate(reqBody)
        setShowCopySimulationTitleModal(false)
      } catch (err) {
        console.log("Some error has occured while duplicating simulation ", err)
      }
    }
  }

  const saveDraftDescription = async (draftDescription) => {
    let description = draftDescription?.trim()
    store.simulationMaindata
    store.selectedSimulationData.description = description
    store.updateStore()
    store.updateSimulationMetadataProperty("description", description, id)
    store.updateSimulationMaindataProperty("description", description, id)
    store.updateOneSimulation(id, { description: description })
  }

  const getOneSimulationsTitle = () => {
    if (qs().review_id && store.selectedReviewData["name"] && store.selectedReviewData["organizationData"] && store.selectedReviewData["engagementData"]) {
      return (
        <>
          <span
            css="cursor: pointer;"
            onClick={() => {
              store.setEngagementManagerFilterLocalStorage({
                orgId: store.selectedReviewData["organizationData"]?.["_id"],
              })
              history.push(SCR_APP_URLS.engagementManager)
            }}
          >
            {store.selectedReviewData["organizationData"]?.["name"]}
          </span>
          &nbsp;/&nbsp;
          <span
            css="cursor: pointer;"
            onClick={() => {
              store.setMyReviewFilterLocalStorage({
                engagementId:
                  store.selectedReviewData["engagementData"]?.["engId"],
              })
              history.push(SCR_APP_URLS.myReview)
            }}
          >
            {store.selectedReviewData["engagementData"]["engId"]}
          </span>
          &nbsp;/&nbsp;
          <span
            css="cursor: pointer;"
            onClick={() => {
              history.push(
                getLibraryURL({
                  engagement_id:
                    store.selectedReviewData["engagementData"]["_id"],
                  review_id: store.selectedReviewData._id,
                }),
              )
            }}
          >
            {store.selectedReviewData["name"]}
          </span>
          &nbsp;/&nbsp;
        </>
      )
    } else {
      return null
    }
  }

  store.useRerenderIfChange(() => [
    store.selectedSimulationMaindataLoading,
    store.selectedSimulationData,
    store.defaultSimulationData,
    store.allSimulations.length,
    store.duplicating,
    store.results?.[0]?.pass_expections,
    store.isReadOnly,
    store.isSaving,
    store.saved,
    store.isDefaultSimulation,
    user.isLoggedIn,
    store.showEnterSimulationNameModal,
    qs().review_id,
    store.steps,
  ])

  return (
    <>
      {simulationError ? (
        <AccessDenied
          notificationIcon={notificationIcon}
          cancelUrl={consts.SCR_APP_URLS.library}
          continueUrl={window["config"].AUTH_UI}
          subtitle={
            <div
              css={`
                font-size: 16px;
                color: #2e2e38;
                margin-top: 12px;
              `}
            >
              <p>
                This simulation does not exist or you must be a member of the
                organization to view this simulation.{" "}
              </p>
              <p>
                Please
                <Link
                  className={classes.link}
                  onClick={() => {
                    redirectToLogin()
                  }}
                >
                  sign in
                </Link>{" "}
                to your enterprise account to continue.
              </p>
            </div>
          }
        />
      ) : (
        <>
          {/* ========================modals start========================*/}
          <ConfirmationModal
            maxWidth="sm"
            title="Delete simulation"
            message={
              "Are you sure you want to delete " +
              store.selectedSimulationData?.name +
              "?"
            }
            open={showDeleteConfirmation}
            onClose={() => {
              setShowDeleteConfirmation(false)
            }}
            confirmationBtnText="Delete simulation"
            onConfirm={() => {
              deleteSimulation()
            }}
          />

          <CustomModal
            medium="medium"
            title="Rename simulation"
            showModal={showRenameSimulationModal}
            onCloseModal={() => {
              setShowRenameSimulationModal(false)
            }}
            submitBtnText={"Update"}
            onSubmit={async (e) => {
              e.preventDefault()
              let updateResponse = await updateSimulationTitle()
              if (updateResponse) {
                setShowRenameSimulationModal(false)
              }
            }}
            submitBtnDisabled={false}
          >
            <>
              <form
                onSubmit={async (e) => {
                  e.preventDefault()
                  let updateResponse = await updateSimulationTitle()
                  if (updateResponse) {
                    setShowRenameSimulationModal(false)
                  }
                }}
              >
                <div css="margin-top: 15px;">
                  <InputText
                    id={"simulationName"}
                    label={"Name"}
                    value={simulationName}
                    disabled={false}
                    autoFocus={true}
                    onChange={(value) => {
                      if(value.trim().length < 201) {
                        setSimulationName(value)
                      }
                    }}
                    hasError={simulationNameHasError}
                    errorText={simulationNameErrorText}
                  />
                </div>
              </form>
            </>
          </CustomModal>

          <CustomModal
            medium="medium"
            title="Create simulation"
            showModal={store.showEnterSimulationNameModal}
            onCloseModal={() => {
              store.closeEnterSimulationNameModal()
            }}
            submitBtnText={"Create"}
            onSubmit={async (e) => {
              e.preventDefault()
              let updateResponse = await updateSimulationTitle()
              if (updateResponse) {
                store.closeEnterSimulationNameModal()
              }
            }}
            onSecondaryRightBtnSubmit={(e) => {
              e.preventDefault()
              onCreateSimulationUsingAIClick()
            }}
            cancelBtnDisabled={secondaryBtnLoading}
            submitBtnDisabled={secondaryBtnLoading}
            secondaryRightBtnText={"Create using AI"}
            secondaryBtnLoading={secondaryBtnLoading}
          >
            <>
              <form
                onSubmit={async (e) => {
                  let updateResponse = await updateSimulationTitle()
                  if (updateResponse) {
                    store.closeEnterSimulationNameModal()
                  }
                }}
              >
                <div css="margin-top: 15px;">
                  <InputText
                    id={"simulationName"}
                    label={"Simulation name"}
                    value={simulationName}
                    disabled={false}
                    autoFocus={true}
                    onChange={(value) => {
                      if(value.trim().length < 201) {
                        setSimulationName(value)
                      }
                    }}
                    hasError={simulationNameHasError}
                    errorText={simulationNameErrorText}
                  />
                </div>
              </form>
              {createSimulationUsingAIerr && (
                <p style={{ color: "red" }}>* {createSimulationUsingAIerr}</p>
              )}
            </>
          </CustomModal>

          <CustomModal
            size="medium"
            title={<div>{ShareIcon} Share simulation</div>}
            showModal={showShareableLinkModal}
            onCloseModal={() => {
              setShareableLink("")
              setShowShareableLinkModal(false)
            }}
            submitBtnText={"Copy link"}
            onSubmit={() => {
              copyShareableLink()
            }}
            submitBtnDisabled={false}
          >
            <>
              <InputLabel htmlFor="shareableLink" className={classes.label}>
                Copy this link to share the simulation.
              </InputLabel>
              <Paper component="form" className={classes.root}>
                <InputBase
                  fullWidth
                  className={classes.input}
                  value={shareableLink}
                  readOnly
                  name={"shareableLink"}
                  id={"shareableLink"}
                />
                <Divider className={classes.divider} orientation="vertical" />
                <IconButton
                  color="primary"
                  className={classes.iconButton}
                  aria-label="directions"
                  onClick={() => copyShareableLink()}
                >
                  {FileCopyIcon}
                </IconButton>
              </Paper>
            </>
          </CustomModal>

          {showCopySimulationTitleModal && (
            <RenameCopiedSimulation
              initialName={store.selectedSimulationData?.name}
              onClose={() => {
                setShowCopySimulationTitleModal(false)
              }}
              onSubmit={(value) => {
                onSubmitCopiedSimulationName(value)
              }}
              showModal={showCopySimulationTitleModal}
            />
          )}
          {/* ========================modals end========================*/}

          {/* ========================main content========================*/}

          <div
            css={`
              background: #f6f6fa;
              min-height: 100vh;
              padding-left: 10px;
              padding-right: 10px;
              padding-bottom: 10px;
              padding-top: 10px;
              position: relative;
            `}
          >
            {props["simulationId"] ? (
              <>
                <div
                  css="
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;"
                >
                  <Button
                    variant="text"
                    onClick={() => {
                      props.onClose()
                    }}
                  >
                    X
                  </Button>
                </div>
              </>
            ) : (
              <>
                <div>
                  <OneSimulationHeader
                    isLoggedIn={user?.isLoggedIn}
                    isCiReview={isCiReview}
                    parentReviewId={parentReviewId}
                  />
                </div>
                <Disclaimer />
                <hr
                  css={`
                    margin-top: 5px;
                    border: 1px solid #eaeaf2;
                  `}
                />
              </>
            )}

            <div
              css={`
                margin-top: 25px;
              `}
            >
              {store.selectedSimulationMaindataLoading && (
                <div>
                  <Progress />
                </div>
              )}

              {store.selectedSimulationData && (
                <div>
                  <div
                    css={`
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      margin-top: 25px;
                      margin-bottom: 25px;
                    `}
                  >
                    <div
                      css={`
                        display: flex;
                        align-items: flex-start;
                        justify-content: space-between;
                        flex-direction: column;
                        flex-grow: 1;
                      `}
                    >
                      <small
                        css={`
                          color: #949494;
                        `}
                      >
                        {getOneSimulationsTitle()}
                      </small>
                      <div
                        css={`
                          display: flex;
                          align-items: center;
                          justify-content: space-between;
                        `}
                      >
                        <div
                          css={
                            store.isReadOnly
                              ? `                                                
                            display:inline;
                            margin-right: 10px;
                            font-size:20px;`
                              : `display:inline;
                            .btn {visibility:hidden;}
                            :hover .btn {
                              visibility:visible;
                            }
                            font-size:20px;`
                          }
                        >
                          {store.selectedSimulationData.sid && (
                            <span>
                              S
                              {String(
                                store.selectedSimulationData.sid,
                              ).padStart(3, "0")}
                              &nbsp;&nbsp;
                            </span>
                          )}
                          {store.selectedSimulationData?.name}
                          {!store.isReadOnly && (
                            <span className="btn">
                              <IconButton
                                onClick={() => {
                                  syncSimulationName()
                                  setShowRenameSimulationModal(true)
                                }}
                                size="small"
                              >
                                {EditIcon()}
                              </IconButton>
                            </span>
                          )}
                        </div>
                        <div>
                          <PassFailChips
                            pass_expections={
                              store?.results?.[0]?.pass_expections
                            }
                          />
                        </div>
                        <div css="margin-left: 20px;">
                          {!store.selectedSimulationData?.public ? (
                            <Tooltip tip={consts.private_tip}>
                              <span>
                                <PrivateIcon />
                              </span>
                            </Tooltip>
                          ) : (
                            <>
                              {!store.selectedSimulationData?.review_id && (
                                <Tooltip tip={consts.public_tip}>
                                  <span>
                                    <PublicIcon />
                                  </span>
                                </Tooltip>
                              )}
                            </>
                          )}
                        </div>
                      </div>

                      <div
                        css={`
                          width: 100%;
                        `}
                      >
                        <Description
                          description={store.selectedSimulationData.description}
                          saveDraftDescription={saveDraftDescription}
                        />
                      </div>
                    </div>

                    <div
                      css={`
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      `}
                    >
                      {user.isLoggedIn && !store.isReadOnly && (
                        <>
                          {!store.saved && !store.isSaving && (
                            <Tooltip tip="Save">
                              <div
                                css={`
                                  cursor: pointer;
                                  margin-left: 10px;
                                `}
                                onClick={async () => {
                                  store.isSaving = true
                                  store.updateStore()
                                  await Promise.all([
                                    store.saveStory(),
                                    delay(500),
                                  ])
                                  store.isSaving = false
                                  store.saved = true
                                  store.updateStore()
                                  await delay(2000)
                                  store.saved = false
                                  store.updateStore()
                                }}
                              >
                                {SaveIcon2()}
                              </div>
                            </Tooltip>
                          )}
                          <Tooltip tip="Saved">
                            {store.saved && SaveIcon}
                          </Tooltip>
                          {store.isSaving && (
                            <Progress time={0} shape="circular" size={24} />
                          )}
                        </>
                      )}

                      {window["config"].SHOW_AI_FUNCTIONALITY == "YES" &&
                        user.isLoggedIn &&
                        !store.isReadOnly &&
                        qs().review_id &&
                        !store.isDefaultSimulation && (
                          <Tooltip tip="Create simulation using AI">
                            <div
                              css={`
                                cursor: pointer;
                                margin-left: 10px;
                              `}
                              onClick={async () => {
                                if (!user.isLoggedIn) {
                                  location.href = window["config"].AUTH_UI
                                  return
                                }
                                syncSimulationName()
                                setCreateSimulationUsingAIerr("")
                                store.openEnterSimulationNameModal()
                              }}
                            >
                              {AIIcon(40)}
                            </div>
                          </Tooltip>
                        )}

                      {user.isLoggedIn &&
                        !store.isReadOnly &&
                        !store.isDefaultSimulation && (
                          <Tooltip tip="Clone simulation">
                            <div
                              css={`
                                cursor: pointer;
                                margin-left: 10px;
                              `}
                              onClick={async () => {
                                if (!user.isLoggedIn) {
                                  location.href = window["config"].AUTH_UI
                                  return
                                }
                                setShowCopySimulationTitleModal(true)
                              }}
                            >
                              {CopyIcon()}
                            </div>
                          </Tooltip>
                        )}

                      {user.isLoggedIn &&
                        !store.isReadOnly &&
                        !store.isDefaultSimulation && (
                          <Tooltip tip="Share simulation">
                            <div
                              css={`
                                cursor: pointer;
                                margin-left: 10px;
                              `}
                              onClick={async () => {
                                setShareableLink(window.location.href)
                                setShowShareableLinkModal(true)
                              }}
                            >
                              {ShareIcon()}
                            </div>
                          </Tooltip>
                        )}

                      {user.isLoggedIn &&
                        !store.isReadOnly &&
                        !store.isDefaultSimulation &&
                        qs().review_id && (
                          <Tooltip tip="Export simulation">
                            <div
                              css={`
                                cursor: pointer;
                                margin-left: 10px;
                              `}
                              onClick={async () => {
                                store.exportSimulationAsJSON()
                              }}
                            >
                              {exportIcon()}
                            </div>
                          </Tooltip>
                        )}

                      {user.isLoggedIn &&
                        !store.isReadOnly &&
                        !store.isDefaultSimulation && (
                          <Tooltip tip="Delete simulation">
                            <div
                              css={`
                                cursor: pointer;
                                margin-left: 10px;
                              `}
                              onClick={() => {
                                if (!user.isLoggedIn) {
                                  location.href = window["config"].AUTH_UI
                                  return
                                }
                                setShowDeleteConfirmation(true)
                              }}
                            >
                              {TrashIcon2()}
                            </div>
                          </Tooltip>
                        )}
                    </div>
                  </div>
                  <hr
                    css={`
                      margin-top: 5px;
                      border: 1px solid #eaeaf2;
                    `}
                  />
                  <div>
                    <VisualBlockchain isLoggedIn={user?.isLoggedIn} simulationId={id} />
                  </div>
                </div>
              )}
            </div>
            <div
              css={`
                position: fixed;
                bottom: 30px;
                right: 30px;
              `}
            >
              <Tooltip tip="Save and play simulation">
                <CFloatButton
                  color="secondary"
                  loading={store.isLoadingResults}
                  disabled={
                    !user?.isLoggedIn ||
                    store.isReadOnly ||
                    store.isLoadingResults ||
                    (store.isMainnet &&
                      window["config"]?.SKIP_SHOW_BLOCK_NUMBERS != "YES" &&
                      !store.blockNumber)
                  }
                  onClick={async () => {
                    store.isLoadingResults = true
                    store.updateStore()
                    await delay(400)
                    await store.saveStory()
                    await delay(100)
                    await store.simulatorTest()
                    store.createLog({
                      simulationId: id,
                      operation: "Execute",
                    })
                  }}
                >
                  {playIcon(35)}
                </CFloatButton>
              </Tooltip>
            </div>
          </div>
        </>
      )}
    </>
  )
}

function Description({ description, saveDraftDescription }) {
  var [editingDescription, setEditiningDescription] = useState(false)
  var [draftDescription, setDraftDescription] = useState("")
  var myRef = useRef()
  return (
    <div
      css={`
        color: #2e2e38;
        margin-top: 14px;
        font-size: 16px;
        width: 100%;
        .edit-btn {
          visibility: hidden;
        }
        :hover .edit-btn {
          visibility: visible;
        }
        textarea {
          display: ${editingDescription ? "block" : "none"};
          width: 100%;
          background: none;
          outline: none;
          border: none;
          font-family: inherit;
          font-size: inherit;
          line-height: inherit;
        }
      `}
    >
      {!editingDescription && (
        <span
          css={`
            white-space: break-spaces;
          `}
        >
          {description}
        </span>
      )}
      {!store.isReadOnly &&
        !editingDescription &&
        !description &&
        "No Description"}
      <TextareaAutosize
        ref={myRef}
        placeholder="Enter description"
        value={draftDescription}
        onChange={(e) => setDraftDescription(e.target.value)}
        onBlur={() => {
          setEditiningDescription(false)
          draftDescription = draftDescription
            .split("\n")
            .map((x) => x.trim())
            .join("\n")
            .trim()
          saveDraftDescription(draftDescription)
        }}
      />
      {!store.isReadOnly && !editingDescription && (
        <span className="edit-btn" css="margin-left: 5px;">
          <IconButton
            onClick={() => {
              //@ts-ignore
              setDraftDescription(description)
              setEditiningDescription(true)
              setTimeout(() => {
                // @ts-ignore
                myRef?.current?.focus()
              }, 200)
            }}
            size="small"
          >
            {EditIcon()}
          </IconButton>
        </span>
      )}
    </div>
  )
}
